export default "__VITE_ASSET__e9615713__"